<app-alert></app-alert>
<app-loader></app-loader>
<div id="labelPrintElement" style="opacity: 0;display: none"></div>
<app-help></app-help>
<app-userGuide-popup></app-userGuide-popup>
<router-outlet></router-outlet>